const $$splitComponentImporter = () => import('/src/src/routes/_authenticated.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_authenticated")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});